module.exports = __webpack_public_path__ + "static/media/bg7-day.29631b95.png";